<section class="hero is-fullheight">
  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="columns">
        <div class="column col-login">
          <div>
            <figure class="logo">
              <img src="../../../../assets/images/logo.svg" alt="logo test" />
            </figure>
            <h3 class="title is-2 mt-5">Welcome to the OECD.AI&nbsp;Portal</h3>
              <div style="height: 3rem;"></div>
              <button
                type="button"
                class="button is-block is-info is-large is-fullwidth mb-3"
                (click)="loginWithKeycloak()"
              >
                <span class="has-text-weight-bold">Sign in</span>
              </button>
          </div>
        </div>
        <div class="column col-decoration">
          <div class="drawing">
            <img src="../../../../assets/images/bg-3.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
